import React, { type ReactNode } from 'react';
import { msg } from '@lingui/macro';
import { useLingui } from '@lingui/react';

import { notify } from './notify';

export type CopyableProps = {
  children: ReactNode;
  copyText?: string;
};

export function Copyable({ children, copyText }: CopyableProps) {
  const { _ } = useLingui();

  return (
    <span
      onClick={() => {
        const text = copyText || children;

        if (typeof text !== 'string') {
          return;
        }

        navigator.clipboard
          .writeText(text)
          .then(() => {
            notify.success(
              _(
                msg({
                  id: 'general.copied',
                  message: 'Copied',
                }),
              ),
            );
          })
          .catch((error) => {
            notify.error('Failed to copy text', error);
          });
      }}
    >
      {children}
    </span>
  );
}
